import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';

const API_URL = '/api';

// --- Ícones ---
const EyeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z" /><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.022 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" /></svg>;
const DotsVerticalIcon = ({ onClick }) => <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white" viewBox="0 0 20 20" fill="currentColor"><path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" /></svg>;
const DownloadIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 inline-block" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" /></svg>;
const ChevronDownIcon = ({ isOpen }) => <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" /></svg>;
const SortIcon = ({ direction }) => {
    if (!direction) return <svg className="h-4 w-4 inline-block text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" /></svg>;
    if (direction === 'ascending') return <svg className="h-4 w-4 inline-block text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>;
    return <svg className="h-4 w-4 inline-block text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>;
};
const SunIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>;
const MoonIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>;
const GearIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>;
const XIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>;
const TaskIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-500" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm0 4a1 1 0 000 2h6a1 1 0 100-2H7zm0 4a1 1 0 000 2h4a1 1 0 100-2H7z" clipRule="evenodd" /></svg>;
const UploadIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clipRule="evenodd" /></svg>;

// --- Helper Functions ---
const abbreviateTipo = (tipo) => {
    switch (tipo) {
        case 'Andamento de publicação em processo de condução terceirizada': return 'Andamento de Publicação';
        case 'Inclusão de Documentos no NPJ': return 'Inclusão de Doc NPJ';
        case 'Doc. anexado por empresa externa em processo terceirizado': return 'Doc Anexado Terceirizada';
        default: return tipo;
    }
};

// --- Componentes Reutilizáveis ---
const StatsCard = ({ title, value, color }) => (
  <div className={`p-4 rounded-lg shadow-md border-l-4 ${color} bg-white dark:bg-gray-800`}>
    <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">{title}</h3>
    <p className="text-3xl font-bold text-gray-800 dark:text-gray-100">{value || 0}</p>
  </div>
);

const StatusTab = ({ status, label, activeStatus, setActiveStatus, count }) => (
  <button
    onClick={() => setActiveStatus(status)}
    className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 ${activeStatus === status ? 'bg-blue-600 text-white shadow' : 'bg-white text-gray-600 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'}`}>
    {label} <span className={`text-xs rounded-full px-2 py-0.5 ml-1 ${activeStatus === status ? 'bg-blue-400 text-white' : 'bg-gray-200 text-gray-700 dark:bg-gray-600 dark:text-gray-200'}`}>{count || 0}</span>
  </button>
);

const Paginacao = ({ currentPage, totalPages, onPageChange, itemsPerPage, onItemsPerPageChange, totalItems }) => {
    if (totalPages <= 1) return null;
    return (
        <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-sm text-gray-600 dark:text-gray-400 gap-4">
            <div className="flex items-center gap-2">
                <span>Itens por página:</span>
                <select value={itemsPerPage} onChange={e => onItemsPerPageChange(Number(e.target.value))} className="border rounded-md p-1 bg-white dark:bg-gray-700 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value={10}>10</option><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
            </div>
            <span>Página {currentPage} de {totalPages} ({totalItems} itens)</span>
            <div>
                <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 border rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 disabled:opacity-50">Anterior</button>
                <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="px-3 py-1 border rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 ml-2 disabled:opacity-50">Próxima</button>
            </div>
        </div>
    );
};

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-[60] p-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md" onClick={e => e.stopPropagation()}>
                <div className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 dark:text-gray-100 mb-4">Confirmação</h3>
                    <p className="text-gray-600 dark:text-gray-300">{message}</p>
                </div>
                <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700 flex justify-end gap-4">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 font-semibold">Cancelar</button>
                    <button onClick={onConfirm} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-semibold">Confirmar</button>
                </div>
            </div>
        </div>
    );
};

const MigrationModal = ({ isOpen, onClose, onMigrationComplete }) => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [migrationMode, setMigrationMode] = useState('adicionar'); // 'adicionar' ou 'conciliar'

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setMessage('');
        setIsError(false);
    };

    const handleUpload = async () => {
        if (!file) {
            setMessage('Por favor, selecione um arquivo.');
            setIsError(true);
            return;
        }

        setUploading(true);
        setMessage('Enviando arquivo...');
        setIsError(false);

        const formData = new FormData();
        formData.append('file', file);

        const endpoint = migrationMode === 'adicionar' ? '/api/migracao' : '/api/migracao/conciliar';

        try {
            const response = await fetch(`${API_URL}${endpoint.substring(4)}`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Erro desconhecido');
            }

            setMessage(data.message);
            setIsError(false);
            onMigrationComplete();
            setTimeout(() => {
                onClose();
            }, 3000);

        } catch (error) {
            setMessage(`Erro: ${error.message}`);
            setIsError(true);
        } finally {
            setUploading(false);
        }
    };

    useEffect(() => {
        if (!isOpen) {
            setFile(null);
            setUploading(false);
            setMessage('');
            setIsError(false);
            setMigrationMode('adicionar');
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg" onClick={e => e.stopPropagation()}>
                <header className="p-4 border-b dark:border-gray-700 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Migrar/Conciliar Notificações</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
                        <XIcon />
                    </button>
                </header>
                <main className="p-6">
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Modo de Operação</label>
                        <div className="flex gap-4">
                            <label className="flex items-center">
                                <input type="radio" value="adicionar" checked={migrationMode === 'adicionar'} onChange={() => setMigrationMode('adicionar')} className="form-radio" />
                                <span className="ml-2 text-gray-700 dark:text-gray-300">Adicionar Pendentes</span>
                            </label>
                            <label className="flex items-center">
                                <input type="radio" value="conciliar" checked={migrationMode === 'conciliar'} onChange={() => setMigrationMode('conciliar')} className="form-radio" />
                                <span className="ml-2 text-gray-700 dark:text-gray-300">Marcar como Tratadas</span>
                            </label>
                        </div>
                    </div>
                    <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
                      {migrationMode === 'adicionar'
                        ? 'Selecione uma planilha (.xlsx ou .csv) com "npj" e "data" para adicionar novas notificações como pendentes.'
                        : 'Selecione uma planilha (.xlsx ou .csv) com "npj" e "data" para encontrar notificações existentes e marcá-las como "Tratada".'
                      }
                    </p>
                    <input
                        type="file"
                        onChange={handleFileChange}
                        accept=".xlsx, .csv"
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                    {file && <p className="text-sm text-gray-500 mt-2">Arquivo selecionado: {file.name}</p>}
                    {message && <p className={`mt-4 text-sm ${isError ? 'text-red-500' : 'text-green-500'}`}>{message}</p>}
                </main>
                <footer className="px-6 py-4 bg-gray-50 dark:bg-gray-700 flex justify-end gap-4">
                    <button onClick={onClose} disabled={uploading} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 font-semibold disabled:opacity-50">Cancelar</button>
                    <button onClick={handleUpload} disabled={uploading} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-semibold disabled:opacity-50 disabled:bg-blue-400">
                        {uploading ? 'Processando...' : (migrationMode === 'adicionar' ? 'Iniciar Migração' : 'Iniciar Conciliação')}
                    </button>
                </footer>
            </div>
        </div>
    );
};

const ModalDetalhes = ({ isOpen, onClose, item, executeUpdateStatus }) => {
    const [step, setStep] = useState('details');
    const [activeAndamento, setActiveAndamento] = useState(null);
    const [detalhes, setDetalhes] = useState(null);
    const [loading, setLoading] = useState(false);
    const [actionError, setActionError] = useState('');

    const { NPJ: npjUpper, npj: npjLower, data_notificacao, numero_processo, ids, responsavel, data_processamento, detalhes_erro } = item || {};
    const npj = npjUpper || npjLower || '';

    useEffect(() => {
        if (isOpen) {
            setStep('details');
            setActionError('');
            if (npj && data_notificacao) {
                setLoading(true);
                setActiveAndamento(null);
                const fetchDetalhes = async () => {
                    try {
                        const url = `${API_URL}/detalhes?npj=${encodeURIComponent(npj)}&data=${encodeURIComponent(data_notificacao)}`;
                        const res = await fetch(url);
                        if (!res.ok) throw new Error('Falha ao buscar detalhes');
                        const data = await res.json();
                        setDetalhes(data);
                    } catch (err) { console.error("Erro ao buscar detalhes:", err); }
                    finally { setLoading(false); }
                };
                fetchDetalhes();
            }
        }
    }, [isOpen, npj, data_notificacao]);

    if (!isOpen || !item) return null;

    const documentViewUrl = (path) => `${API_URL}/documentos/view?path=${encodeURIComponent(path)}`;
    const documentDownloadUrl = (path) => `${API_URL}/download?path=${encodeURIComponent(path)}`;

    const handleViewDocument = (path) => {
        window.open(documentViewUrl(path), '_blank', 'noopener,noreferrer');
    };

    const handleDownload = async (path) => {
        try {
            const response = await fetch(documentDownloadUrl(path));
            if (!response.ok) throw new Error('Falha no download');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = path.split(/[\\/]/).pop();
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) { console.error("Erro no download:", error); }
    };

    const handleFinalizar = async (gerouTarefa) => {
        setActionError('');
        const updated = await executeUpdateStatus([ids], 'Tratada', gerouTarefa);
        if (updated) {
            onClose();
        } else {
            setActionError('Não foi possível marcar como tratada. Recarregue a lista e tente novamente.');
        }
    };

    const renderContent = () => {
        switch (step) {
            case 'decision':
                return (
                    <div className="p-6 text-center flex-grow flex flex-col justify-center">
                        <h3 className="text-lg font-bold text-gray-800 dark:text-gray-100 mb-4">A finalização desta notificação gerou uma tarefa?</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400">Isso registrará se a tarefa foi criada manualmente no Legal One.</p>
                        {actionError && <p className="mt-3 text-sm text-red-600 dark:text-red-400">{actionError}</p>}
                        <div className="flex justify-center gap-4 mt-6">
                            <button onClick={() => handleFinalizar(1)} className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-semibold">Sim</button>
                            <button onClick={() => handleFinalizar(0)} className="px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 font-semibold">Não</button>
                        </div>
                    </div>
                );
            case 'details':
            default:
                return (
                     <main className="p-4 flex-grow overflow-y-auto grid grid-cols-1 md:grid-cols-2 gap-6">
                        {loading ? <p className="text-center col-span-2 dark:text-gray-300">Carregando detalhes...</p> :
                            <>
                                <div className="flex flex-col">
                                    <h3 className="font-bold mb-2 text-gray-700 dark:text-gray-200">Andamentos Capturados</h3>
                                    <div className="border rounded-md p-2 overflow-y-auto flex-grow h-96 dark:border-gray-700">
                                        {detalhes?.andamentos?.length > 0 ? (
                                            detalhes.andamentos.map((andamento, index) => (
                                                <div key={index} className="border-b last:border-b-0 dark:border-gray-700">
                                                    <button onClick={() => setActiveAndamento(activeAndamento === index ? null : index)} className="w-full text-left p-2 hover:bg-gray-100 dark:hover:bg-gray-700 flex justify-between items-center">
                                                        <span className="font-medium text-sm text-gray-800 dark:text-gray-200">{andamento.data} - {andamento.descricao}</span>
                                                        <ChevronDownIcon isOpen={activeAndamento === index} />
                                                    </button>
                                                    {activeAndamento === index && (
                                                        <div className="p-3 bg-gray-50 dark:bg-gray-900 text-xs text-gray-700 dark:text-gray-300 whitespace-pre-wrap">{andamento.detalhes}</div>
                                                    )}
                                                </div>
                                            ))
                                        ) : <p className="text-sm text-gray-500 dark:text-gray-400 p-2">Nenhum andamento capturado.</p>}
                                    </div>
                                </div>
                                <div className="flex flex-col">
                                    <h3 className="font-bold mb-2 text-gray-700 dark:text-gray-200">Documentos Baixados</h3>
                                    <div className="border rounded-md p-2 overflow-y-auto flex-grow h-96 dark:border-gray-700">
                                       {detalhes?.documentos?.length > 0 ? (
                                            detalhes.documentos.map((doc, index) => (
                                                <div key={index} className="p-2 border-b last:border-b-0 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm">
                                                    <div className="text-gray-800 dark:text-gray-200 break-all mb-2">{doc.nome}</div>
                                                    <div className="flex flex-wrap gap-3">
                                                        <button onClick={() => handleViewDocument(doc.caminho)} className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:underline">
                                                            <EyeIcon /> <span className="ml-1">Visualizar</span>
                                                        </button>
                                                        <button onClick={() => handleDownload(doc.caminho)} className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:underline">
                                                            <DownloadIcon /> Baixar
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                       ) : <p className="text-sm text-gray-500 dark:text-gray-400 p-2">Nenhum documento baixado.</p>}
                                    </div>
                                </div>
                            </>
                        }
                     </main>
                );
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4" onClick={onClose}>
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col relative" onClick={e => e.stopPropagation()}>
                <header className="p-4 border-b dark:border-gray-700 sticky top-0 bg-white dark:bg-gray-800 z-10">
                    <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
                        <XIcon />
                    </button>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Detalhes do Processamento</h2>
                    <div className="text-sm text-gray-600 dark:text-gray-400 mt-2 flex flex-wrap gap-x-4 gap-y-1">
                        <span><strong>NPJ:</strong> {npj}</span>
                        {numero_processo && <span><strong>Nº Processo:</strong> {numero_processo}</span>}
                        <span><strong>Data:</strong> {data_notificacao}</span>
                        {responsavel && <span className="text-xs text-gray-500 dark:text-gray-400 mt-1"><strong>Responsável:</strong> {responsavel}</span>}
                        {data_processamento && <span className="text-xs text-gray-500 dark:text-gray-400 mt-1"><strong>Processado em:</strong> {data_processamento}</span>}
                    </div>
                </header>

                {detalhes_erro && (
                    <div className="p-4 bg-red-50 dark:bg-red-900 border-b border-t border-red-200 dark:border-red-800">
                        <h3 className="font-bold text-red-800 dark:text-red-200 mb-2">Detalhes do Erro</h3>
                        <pre className="text-xs text-red-700 dark:text-red-300 whitespace-pre-wrap font-mono bg-transparent p-0">{detalhes_erro}</pre>
                    </div>
                )}

                {renderContent()}

                {step === 'details' && (
                    <footer className="p-3 border-t dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex justify-end sticky bottom-0">
                        <button onClick={() => setStep('decision')} className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-semibold">
                            Finalizar
                        </button>
                    </footer>
                )}
            </div>
        </div>
    );
};


// --- Componente Principal ---
function App() {
    const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
    useEffect(() => {
        const root = window.document.documentElement;
        root.classList.remove(theme === 'light' ? 'dark' : 'light');
        root.classList.add(theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => setTheme(theme === 'light' ? 'dark' : 'light');

    const [stats, setStats] = useState({ pendente: 0, processado: 0, erro: 0, erro_data_invalida: 0, arquivado: 0, tratada: 0, migrado: 0 });
    const [notificacoes, setNotificacoes] = useState([]);
    const [statusFiltro, setStatusFiltro] = useState('Processado');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [filtroBusca, setFiltroBusca] = useState('');
    const [debouncedFiltroBusca, setDebouncedFiltroBusca] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'data_notificacao', direction: 'descending' });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [selectedIds, setSelectedIds] = useState([]);
    const [modalDetalhes, setModalDetalhes] = useState({ isOpen: false, item: null });
    const [showUserManagement, setShowUserManagement] = useState(false);
    const [showMigrationModal, setShowMigrationModal] = useState(false);
    const [listaUsuarios, setListaUsuarios] = useState([]);
    const [responsavelFiltro, setResponsavelFiltro] = useState('Todos');
    const [poloFiltro, setPoloFiltro] = useState('Todos');
    const [activeActionMenu, setActiveActionMenu] = useState(null);
    const menuRef = useRef(null);
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, onConfirm: () => {}, message: '' });

    const [legalOneUsers, setLegalOneUsers] = useState([]);
    const [legalOneTasks, setLegalOneTasks] = useState([]);

    // ADICIONADO: Novo estado para o filtro de data
    const [dataFiltro, setDataFiltro] = useState('');

    const fetchInitialData = useCallback(async () => {
        try {
            const [statsRes, usersRes, legalOneUsersRes, legalOneTasksRes] = await Promise.all([
                fetch(`${API_URL}/stats`),
                fetch(`${API_URL}/usuarios`),
                fetch(`${API_URL}/legalone/users`),
                fetch(`${API_URL}/legalone/tasks`),
            ]);
            if (!statsRes.ok || !usersRes.ok || !legalOneUsersRes.ok || !legalOneTasksRes.ok) throw new Error('Falha ao carregar dados iniciais');

            setStats(await statsRes.json());
            setListaUsuarios(await usersRes.json());
            setLegalOneUsers(await legalOneUsersRes.json());
            setLegalOneTasks(await legalOneTasksRes.json());
        } catch (err) {
            setError(err.message);
        }
    }, []);

    const fetchAllData = useCallback(async () => {
        setLoading(true);
        setError('');
        setSelectedIds([]);
        try {
            const offset = (currentPage - 1) * itemsPerPage;
            let url = `${API_URL}/notificacoes?status=${encodeURIComponent(statusFiltro)}&limit=${itemsPerPage}&offset=${offset}&sort=${encodeURIComponent(sortConfig.key)}&direction=${encodeURIComponent(sortConfig.direction)}`;
            if (responsavelFiltro !== 'Todos') url += `&responsavel=${encodeURIComponent(responsavelFiltro)}`;
            if (poloFiltro !== 'Todos') url += `&polo=${encodeURIComponent(poloFiltro)}`;
            if (dataFiltro) url += `&data=${dataFiltro}`;
            if (debouncedFiltroBusca) url += `&search=${encodeURIComponent(debouncedFiltroBusca)}`;

            const notificacoesRes = await fetch(url);
            if (!notificacoesRes.ok) throw new Error('Falha ao carregar notificações');

            const payload = await notificacoesRes.json();
            if (Array.isArray(payload)) {
                setNotificacoes(payload);
                setTotalItems(payload.length);
            } else {
                setNotificacoes(payload.items || []);
                setTotalItems(payload.total || 0);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [statusFiltro, responsavelFiltro, poloFiltro, dataFiltro, debouncedFiltroBusca, currentPage, itemsPerPage, sortConfig]);

    useEffect(() => { fetchInitialData(); }, [fetchInitialData]);
    useEffect(() => { fetchAllData(); }, [fetchAllData]);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedFiltroBusca(filtroBusca.trim()), 350);
        return () => clearTimeout(timer);
    }, [filtroBusca]);

    useEffect(() => {
        setCurrentPage(1);
    }, [responsavelFiltro, poloFiltro, dataFiltro, debouncedFiltroBusca]);

    const currentTableData = notificacoes;

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') direction = 'descending';
        setSortConfig({ key, direction });
        setCurrentPage(1);
    };

    const handleStatusChange = (newStatus) => {
        setStatusFiltro(newStatus);
        setCurrentPage(1);
        setFiltroBusca('');
        setResponsavelFiltro('Todos');
        setPoloFiltro('Todos');
        setDataFiltro(''); // ADICIONADO: Reseta o filtro de data
    };

    const executeUpdateStatus = async (ids, novo_status, gerou_tarefa) => {
        const flatIds = ids.flatMap(idStr => String(idStr).split(';')).filter(Boolean);
        try {
         const body = { ids: flatIds, novo_status };
         if (novo_status === 'Tratada') {
           body.gerou_tarefa = gerou_tarefa;
         }
         const response = await fetch(`${API_URL}/acoes/status`, {
           method: 'POST',
           headers: { 'Content-Type': 'application/json' },
           body: JSON.stringify(body),
         });
         if (!response.ok) {
           const errorData = await response.json().catch(() => ({}));
           throw new Error(errorData.error || "Falha ao executar ação.");
         }
         fetchInitialData();
         fetchAllData();
         return true;
        } catch (err) {
         console.error(err);
         setError(err.message);
         return false;
        } finally {
         setConfirmationModal({ isOpen: false, onConfirm: () => {}, message: '' });
        }
    };

    const handleAction = (ids, action) => {
        if (!ids || ids.length === 0) return;

        if (action === 'Tratada') {
            setConfirmationModal({
                isOpen: true,
                onConfirm: () => executeUpdateStatus(ids, 'Tratada', 0),
                message: "Você confirma que esta(s) notificação(ões) será(ão) marcada(s) como 'Tratada(s)' sem a criação de novas tarefas?"
            });
        } else {
            executeUpdateStatus(ids, action);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
         const allIdsOnPage = currentTableData.map(item => item.ids);
         setSelectedIds(allIdsOnPage);
        } else {
         setSelectedIds([]);
        }
    };

    const handleSelectOne = (e, ids) => {
        if (e.target.checked) {
         setSelectedIds(prev => [...prev, ids]);
        } else {
         setSelectedIds(prev => prev.filter(id => id !== ids));
        }
    };

    const allOnPageSelected = useMemo(() =>
        currentTableData.length > 0 && currentTableData.every(item => selectedIds.includes(item.ids)),
        [currentTableData, selectedIds]
    );

    const someOnPageSelected = useMemo(() =>
        currentTableData.some(item => selectedIds.includes(item.ids)),
        [currentTableData, selectedIds]
    );

    const masterCheckboxRef = useRef(null);
    useEffect(() => {
        if (masterCheckboxRef.current) {
         masterCheckboxRef.current.indeterminate = someOnPageSelected && !allOnPageSelected;
        }
    }, [someOnPageSelected, allOnPageSelected]);


    useEffect(() => {
        const handleClickOutside = (event) => {
         if (menuRef.current && !menuRef.current.contains(event.target)) {
           setActiveActionMenu(null);
         }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="bg-gray-100 dark:bg-gray-900 min-h-screen p-4 sm:p-6 lg:p-8 font-sans">
          <header className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100">OneNotify</h1>
            <div className="flex items-center gap-4">
                <button onClick={toggleTheme} className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
                    {theme === 'light' ? <MoonIcon /> : <SunIcon />}
                </button>
                <button onClick={() => setShowMigrationModal(true)} className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 border border-purple-700 rounded-lg shadow-sm text-sm flex items-center">
                    <UploadIcon /> Migrar/Conciliar
                </button>
                <button onClick={() => setShowUserManagement(!showUserManagement)} className="bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-semibold py-2 px-4 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm text-sm">
                    {showUserManagement ? 'Ver Notificações' : 'Gerenciar Responsáveis'}
                </button>
            </div>
          </header>

          {showUserManagement ? ( <UserManagement users={listaUsuarios} onUserChange={fetchAllData} /> ) : (
            <>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-4 mb-6">
                    <StatsCard title="Pendentes" value={stats.pendente} color="border-yellow-400" />
                    <StatsCard title="Processados" value={stats.processado} color="border-green-400" />
                    <StatsCard title="Tratadas" value={stats.tratada} color="border-blue-400" />
                    <StatsCard title="Migrados" value={stats.migrado} color="border-purple-400" />
                    <StatsCard title="Com Erro" value={stats.erro} color="border-red-400" />
                    <StatsCard title="Erro de Dados" value={stats.erro_data_invalida} color="border-orange-400" />
                    <StatsCard title="Arquivados" value={stats.arquivado} color="border-gray-400" />
                </div>
                <div className="flex flex-wrap gap-2 mb-4">
                    <StatusTab status="Pendente" label="Pendentes" activeStatus={statusFiltro} setActiveStatus={handleStatusChange} count={stats.pendente} />
                    <StatusTab status="Processado" label="Processados" activeStatus={statusFiltro} setActiveStatus={handleStatusChange} count={stats.processado} />
                    <StatusTab status="Tratada" label="Tratadas" activeStatus={statusFiltro} setActiveStatus={handleStatusChange} count={stats.tratada} />
                    <StatusTab status="Migrado" label="Migrados" activeStatus={statusFiltro} setActiveStatus={handleStatusChange} count={stats.migrado} />
                    <StatusTab status="Erro" label="Erro" activeStatus={statusFiltro} setActiveStatus={handleStatusChange} count={stats.erro} />
                    <StatusTab status="Arquivado" label="Arquivados" activeStatus={statusFiltro} setActiveStatus={handleStatusChange} count={stats.arquivado} />
                </div>

                <div className="bg-white dark:bg-gray-800 p-4 sm:p-6 rounded-lg shadow-md">
                    <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-4">
                        <div className="flex items-center gap-2 md:gap-4 flex-wrap">
                          <input type="text" placeholder="Buscar por NPJ ou Nº Processo..." value={filtroBusca} onChange={e => setFiltroBusca(e.target.value)} className="border rounded-md py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-200 border-gray-300 dark:border-gray-600" />
                          <select value={responsavelFiltro} onChange={e => setResponsavelFiltro(e.target.value)} className="border rounded-md py-2 px-3 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-200 border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto">
                            <option value="Todos">Todos os Responsáveis</option>
                            <option value="Sem Responsável">Sem Responsável</option>
                            {listaUsuarios.map(user => <option key={user.id} value={user.nome}>{user.nome}</option>)}
                          </select>
                          <select value={poloFiltro} onChange={e => setPoloFiltro(e.target.value)} className="border rounded-md py-2 px-3 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-200 border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto">
                            <option value="Todos">Todos os Polos</option>
                            <option value="Ativo">Ativo</option>
                            <option value="Passivo">Passivo</option>
                          </select>
                          {/* ADICIONADO: Campo de filtro por data */}
                          <div className="relative">
                            <input type="date" value={dataFiltro} onChange={e => setDataFiltro(e.target.value)} className="border rounded-md py-2 px-3 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-200 border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto" />
                            {dataFiltro && (
                                <button onClick={() => setDataFiltro('')} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                                    <XIcon className="h-4 w-4" />
                                </button>
                            )}
                          </div>

                        </div>
                        <div className="relative" ref={menuRef}>
                            <button onClick={() => setActiveActionMenu(activeActionMenu === 'batch' ? null : 'batch')} disabled={selectedIds.length === 0} className="bg-blue-500 text-white font-bold py-2 px-4 rounded-md text-sm disabled:bg-gray-400 dark:disabled:bg-gray-600 flex items-center gap-2">
                               <GearIcon />
                               <span>({selectedIds.length})</span>
                            </button>
                            {activeActionMenu === 'batch' && (
                                 <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-700 rounded-md shadow-lg z-20">
                                    {statusFiltro !== 'Tratada' && <button onClick={() => {handleAction(selectedIds, 'Tratada'); setActiveActionMenu(null);}} className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600">Marcar como Tratada</button>}
                                    {statusFiltro !== 'Pendente' && <button onClick={() => {handleAction(selectedIds, 'Pendente'); setActiveActionMenu(null);}} className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600">Marcar como Pendente</button>}
                                    {statusFiltro !== 'Arquivado' && <button onClick={() => {handleAction(selectedIds, 'Arquivado'); setActiveActionMenu(null);}} className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600">Arquivar</button>}
                                 </div>
                            )}
                        </div>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 table-fixed">
                            <thead className="bg-gray-50 dark:bg-gray-700">
                               <tr>
                                    <th className="p-4 w-12 text-left">
                                        <input type="checkbox" ref={masterCheckboxRef} checked={allOnPageSelected} onChange={handleSelectAll} className="rounded" />
                                    </th>
                                    <th className="w-[10%] px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('data_notificacao')}>Data <SortIcon direction={sortConfig.key === 'data_notificacao' ? sortConfig.direction : null}/></th>
                                    <th className="w-[25%] px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('NPJ')}>NPJ <SortIcon direction={sortConfig.key === 'NPJ' ? sortConfig.direction : null}/></th>
                                    <th className="w-[15%] px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Nº Processo</th>
                                    <th className="w-[10%] px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Polo</th>
                                    <th className="w-[25%] px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Tipos de Notificação</th>
                                    <th className="w-[15%] px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('responsavel')}>Responsável <SortIcon direction={sortConfig.key === 'responsavel' ? sortConfig.direction : null}/></th>
                                    <th className="w-[5%] px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Detalhes</th>
                                    <th className="w-[5%] px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Ações</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                {loading ? <tr><td colSpan="8" className="text-center p-4 dark:text-gray-300">Carregando...</td></tr> :
                                 error ? <tr><td colSpan="8" className="text-center p-4 text-red-500">{error}</td></tr> :
                                 currentTableData.map(item => {
                                    const itemNpj = item.NPJ || item.npj || '';
                                    const itemKey = itemNpj + item.data_notificacao;
                                    return (
                                    <tr key={itemKey} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                                        <td className="p-4">
                                            <input type="checkbox" checked={selectedIds.includes(item.ids)} onChange={(e) => handleSelectOne(e, item.ids)} className="rounded" />
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">{item.data_notificacao}</td>
                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 flex items-center gap-2">
                                            {itemNpj}
                                            {item.gerou_tarefa === 1 && <TaskIcon />}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 truncate">{item.numero_processo || '-'}</td>
                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 flex items-center gap-2">
                                            {item.polo || '-'}
                                        </td>

                                        <td className="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                                            <div className="flex flex-wrap gap-1">
                                                {item.tipos_notificacao && item.tipos_notificacao.split('; ').map(tipo => (
                                                    <span key={tipo} className="text-xs bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 px-2 py-0.5 rounded-full">{abbreviateTipo(tipo)}</span>
                                                ))}
                                            </div>
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">{item.responsavel || '-'}</td>
                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-center">
                                            <button onClick={() => setModalDetalhes({ isOpen: true, item })} className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-200"><EyeIcon /></button>
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-center">
                                             <div className="relative" ref={activeActionMenu === itemKey ? menuRef : null}>
                                                <DotsVerticalIcon onClick={() => setActiveActionMenu(activeActionMenu === itemKey ? null : itemKey)} />
                                                {activeActionMenu === itemKey && (
                                                    <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-700 rounded-md shadow-lg z-20">
                                                        {item.status !== 'Tratada' && <button onClick={() => {handleAction([item.ids], 'Tratada'); setActiveActionMenu(null);}} className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600">Marcar como Tratada</button>}
                                                        {item.status !== 'Pendente' && <button onClick={() => {handleAction([item.ids], 'Pendente'); setActiveActionMenu(null);}} className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600">Marcar como Pendente</button>}
                                                        {item.status !== 'Arquivado' && <button onClick={() => {handleAction([item.ids], 'Arquivado'); setActiveActionMenu(null);}} className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600">Arquivar</button>}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )})}
                            </tbody>
                        </table>
                    </div>

                    <Paginacao
                        currentPage={currentPage} totalPages={Math.ceil(totalItems / itemsPerPage)}
                        onPageChange={setCurrentPage} itemsPerPage={itemsPerPage}
                        onItemsPerPageChange={(value) => { setItemsPerPage(value); setCurrentPage(1); }}
                        totalItems={totalItems}
                    />
                </div>
            </>
          )}

          <MigrationModal
            isOpen={showMigrationModal}
            onClose={() => setShowMigrationModal(false)}
            onMigrationComplete={fetchAllData}
          />
          <ConfirmationModal
            isOpen={confirmationModal.isOpen}
            onClose={() => setConfirmationModal({ isOpen: false, onConfirm: () => {}, message: '' })}
            onConfirm={confirmationModal.onConfirm}
            message={confirmationModal.message}
          />
          <ModalDetalhes
            isOpen={modalDetalhes.isOpen}
            onClose={() => setModalDetalhes({ isOpen: false, item: null })}
            item={modalDetalhes.item}
            executeUpdateStatus={executeUpdateStatus}
            legalOneUsers={legalOneUsers}
            legalOneTasks={legalOneTasks}
          />
        </div>
      );
}

// --- Gerenciador de Usuários ---
const UserManagement = ({ users, onUserChange }) => {
    const [newUserName, setNewUserName] = useState('');
    const [newUserProfile, setNewUserProfile] = useState('Geral');
    const [error, setError] = useState('');

    const handleAddUser = async (e) => {
        e.preventDefault();
        setError('');
        if (!newUserName.trim()) { setError('O nome não pode ser vazio.'); return; }
        try {
            const response = await fetch(`${API_URL}/usuarios`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nome: newUserName, perfil: newUserProfile }),
            });
            if (!response.ok) {
                const errData = await response.json();
                throw new Error(errData.error || 'Falha ao adicionar usuário');
            }
            setNewUserName('');
            setNewUserProfile('Geral');
            onUserChange();
        } catch (err) { setError(err.message); }
    };

    const handleDeleteUser = async (userId) => {
        try {
            const response = await fetch(`${API_URL}/usuarios/${userId}`, { method: 'DELETE' });
            if (!response.ok) throw new Error('Falha ao remover usuário');
            onUserChange();
        } catch (err) { setError(err.message); }
    };

    const handleProfileChange = async (userId, newProfile) => {
        try {
            const response = await fetch(`${API_URL}/usuarios/${userId}/perfil`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ perfil: newProfile }),
            });
            if (!response.ok) {
                const errData = await response.json();
                throw new Error(errData.error || 'Falha ao atualizar perfil.');
            }
            onUserChange();
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md max-w-4xl mx-auto">
            <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-100">Gerenciar Responsáveis</h2>
            {error && <p className="text-red-500 mb-4">{error}</p>}
            <form onSubmit={handleAddUser} className="flex flex-col sm:flex-row items-center gap-2 mb-6">
                <input type="text" value={newUserName} onChange={e => setNewUserName(e.target.value)} placeholder="Nome do novo responsável" className="border rounded-md py-2 px-3 flex-grow focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-200 border-gray-300 dark:border-gray-600 w-full" />
                <select value={newUserProfile} onChange={e => setNewUserProfile(e.target.value)} className="border rounded-md py-2 px-3 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-200 border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto">
                    <option value="Geral">Geral</option>
                    <option value="Polo Ativo">Polo Ativo</option>
                </select>
                <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md w-full sm:w-auto">Adicionar</button>
            </form>
            <div className="space-y-2">
                {users.map(user => (
                    <div key={user.id} className="grid grid-cols-3 items-center p-3 border rounded-md bg-gray-50 dark:bg-gray-700 dark:border-gray-600 gap-4">
                        <span className="font-medium text-gray-700 dark:text-gray-200 col-span-1">{user.nome}</span>
                        <div className="col-span-1">
                            <select value={user.perfil || 'Geral'} onChange={(e) => handleProfileChange(user.id, e.target.value)} className="border rounded-md py-1 px-2 text-sm bg-white dark:bg-gray-600 text-gray-900 dark:text-gray-200 border-gray-300 dark:border-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 w-full">
                                <option value="Geral">Geral</option>
                                <option value="Polo Ativo">Polo Ativo</option>
                            </select>
                        </div>
                        <div className="col-span-1 text-right">
                           <button onClick={() => handleDeleteUser(user.id)} className="text-red-500 hover:text-red-700 font-semibold text-sm">Remover</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default App;

